import { memo } from 'react';

import { useCuracao } from './use-curacao';

function CuracaoUI() {
  const { id } = useCuracao();

  return id ? (
    <iframe
      className="sb-Curacao"
      height="50"
      scrolling="no"
      src={`https://licensing.gaming-curacao.com/validator/?lh=${id}&template=tseal`}
      style={{ border: 'none' }}
      title="Curacao license"
      width="150"
    />
  ) : null;
}

export const Curacao = memo(CuracaoUI);
